package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.WhiteboardAction
import fr.manyverse.app.domain.repository.WhiteboardRepository

/**
 * Use case for toggling the grid visibility on the whiteboard.
 * Broadcasts the toggle action to all participants and updates the whiteboard state.
 */
class ToggleWhiteboardGridUseCase(
    private val whiteboardRepository: WhiteboardRepository
) {
    /**
     * Toggles the grid visibility on the whiteboard.
     *
     * @param tableId The game table ID
     * @param whiteboardId The whiteboard ID
     * @param showGrid Whether to show the grid
     * @param performedBy The user ID who toggled the grid
     * @return Result indicating success or failure
     */
    suspend operator fun invoke(
        tableId: String,
        whiteboardId: String,
        showGrid: Boolean,
        performedBy: String
    ): Result<Unit> {
        // Update the whiteboard state
        whiteboardRepository.updateGridState(
            whiteboardId = whiteboardId,
            showGrid = showGrid
        ).onFailure {
            return Result.failure(it)
        }

        // Broadcast the action
        val action = WhiteboardAction.ToggleGrid(showGrid = showGrid)

        return whiteboardRepository.broadcastAction(
            tableId = tableId,
            whiteboardId = whiteboardId,
            action = action,
            performedBy = performedBy
        )
    }
}
